export default {"src":"/_next/static/media/logo-white.6b8bc6d0.svg","height":102,"width":300,"blurWidth":0,"blurHeight":0};